import { render, staticRenderFns } from "./BalanceSheets.vue?vue&type=template&id=5a45e7ea&scoped=true&"
import script from "./BalanceSheets.vue?vue&type=script&lang=js&"
export * from "./BalanceSheets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a45e7ea",
  null
  
)

export default component.exports